import axios from "axios";
import { logout } from "../lib/auth";

import { EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";

// 上位店入金単価一覧取得（検索条件でサブテーブル絞り込み）
export async function getHighRankCompanyDeposits(
  id: string,
  payment_method_id: string,
  filter?: {
    deposit_start_date_start?: string;
    deposit_start_date_end?: string;
  }
) {
  try {
    const path = "highRankCompanyDeposits";
    const params: Record<string, string> = { id, payment_method_id };
    if (filter?.deposit_start_date_start)
      params.deposit_start_date_start = filter.deposit_start_date_start;
    if (filter?.deposit_start_date_end)
      params.deposit_start_date_end = filter.deposit_start_date_end;
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}
// 上位店入金単価詳細取得
export async function getHighRankCompanyDeposit(id: string) {
  try {
    const path = "highRankCompanyDeposit";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    return response.data.detail_data[0];
  } catch (error) {}
}
// 上位店入金単価詳細編集
export async function putHighRankCompanyDeposit(editData: EditDataDifine) {
  try {
    const path = "highRankCompanyDeposit";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
      payment_method_id: editData.payment_method_id,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 上位店入金単価登録
export async function postHighRankCompanyDeposit(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "highRankCompanyDeposit";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// 上位店入金単価削除
export async function deleteHighRankCompanyDeposit(id: string) {
  try {
    const path = "highRankCompanyDeposit";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}
